import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
const slides = [
  {
    title: "Independent Audit, Compliance & Assurance",
    text: "Strengthening governance and compliance through structured audit frameworks and evidence-based reporting."
  },
  {
    title: "AI-Driven Software & Digital Intelligence",
    text: "Designing intelligent platforms that enable automation, predictive insights, and operational excellence."
  },
  {
    title: "Enterprise & Government Mobile Solutions",
    text: "Secure, scalable mobile applications supporting field operations, inspections, and real-time reporting."
  }
];

const Home = () => {




  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          DSAP Solutions | Audit, Compliance & AI-Driven Digital Solutions
        </title>

        <meta
          name="description"
          content="DSAP Solutions provides independent audit, inspection, compliance, risk advisory, AI-driven software development, and enterprise mobile app development services across India."
        />

        <meta
          name="keywords"
          content="DSAP Solutions, audit services India, compliance audit, government audit services, AI software development India, enterprise mobile apps"
        />

        {/* Open Graph */}
        <meta property="og:title" content="DSAP Solutions | Audit & AI Digital Solutions" />
        <meta
          property="og:description"
          content="Independent audit, compliance, AI software development and mobile app development services for government and enterprises."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.dsapsolutions.in" />
      </Helmet>
      {/* HERO SLIDER */}
      <section className="hero">
        <div className="container">
          <div key={index} className="hero-slide">
            <h1>{slides[index].title}</h1>
            <p>{slides[index].text}</p>
          </div>
        </div>
      </section>


      {/* TRUST STRIP */}
      <section className="section light">
        <div className="container trust-strip">
          <div>
            <h3>1500+</h3>
            <p>Audits Executed</p>
          </div>
          <div>
            <h3>Pan-India</h3>
            <p>Deployment Capability</p>
          </div>
          <div>
            <h3>Govt & PSU</h3>
            <p>Program Experience</p>
          </div>
          <div>
            <h3>AI-Enabled</h3>
            <p>Decision Intelligence</p>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="section">
        <div className="container">
          <h2>About DSAP Solutions</h2>
          <p>
            DSAP Solutions is a leading independent third-party audit,
            inspection, compliance, and risk advisory firm in India.
            We work with government bodies, public sector organizations,
            and enterprises to deliver structured assurance services
            backed by strong governance frameworks and on-ground execution.
          </p>
          <p>
            Alongside traditional assurance, we design AI-driven software
            and mobile solutions that enable automation, real-time
            visibility, and predictive insights—without compromising
            transparency or audit integrity.
          </p>
        </div>
      </section>

      {/* CORE SERVICES */}
      <section className="section light">
        <div className="container">
          <h2>Our Core Capabilities</h2>

          <div className="grid">
            <div className="card">
              <h3>Audit & Inspection</h3>
              <p>
                Independent audits, NSDC/NSTC centre assessments,
                government program verification, and structured
                field inspections with evidence-based reporting.
              </p>
            </div>

            <div className="card">
              <h3>Internal Audit & Compliance</h3>
              <p>
                Corporate internal audits, regulatory compliance
                reviews, operational risk assessments, and
                compliance maturity evaluations.
              </p>
            </div>

            <div className="card">
              <h3>Risk & Control Advisory</h3>
              <p>
                Risk identification, control framework evaluation,
                policy & SOP reviews, and remediation roadmaps
                aligned to regulatory standards.
              </p>
            </div>

            <div className="card">
              <h3>AI-Enabled Intelligence</h3>
              <p>
                Predictive analytics, intelligent dashboards,
                automated document validation, and AI-supported
                compliance monitoring systems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AI SOFTWARE & MOBILE */}
      <section className="section">
        <div className="container">
          <h2>AI-Driven Software & Mobile Solutions</h2>
          <p>
            We design and build intelligent digital platforms that
            support governance, operational efficiency, and
            data-driven decision-making across organisations.
          </p>

          <div className="grid">
            <div className="card">
              <h3>AI-Driven Software Development</h3>
              <ul>
                <li>Custom AI-enabled ERP & MIS systems</li>
                <li>Predictive analytics & forecasting engines</li>
                <li>Process automation & intelligent workflows</li>
                <li>Risk, compliance & audit intelligence platforms</li>
                <li>Secure, scalable, audit-ready architectures</li>
              </ul>
            </div>

            <div className="card">
              <h3>Mobile App Development</h3>
              <ul>
                <li>Android & iOS enterprise applications</li>
                <li>Field inspection & audit mobility apps</li>
                <li>POS, inventory & workforce management apps</li>
                <li>Offline-first & low-connectivity support</li>
                <li>API-integrated, cloud-ready solutions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY DSAP */}
      <section className="section dark">
        <div className="container">
          <h2>Why DSAP Solutions</h2>
          <ul className="why-list">
            <li>Strong government & enterprise domain expertise</li>
            <li>Pan-India execution with trained field teams</li>
            <li>Evidence-based reporting & governance focus</li>
            <li>AI used responsibly as decision-support</li>
            <li>End-to-end consulting, technology & support</li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default Home;
